import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=fa0ef1f4&scoped=true"
import script from "./Keywords.vue?vue&type=script&lang=js"
export * from "./Keywords.vue?vue&type=script&lang=js"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=fa0ef1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0ef1f4",
  null
  
)

export default component.exports